// extracted by mini-css-extract-plugin
export default {"extraChartPreferences":"PreferencesFormComponent_extraChartPreferences__kg3hF","title":"PreferencesFormComponent_title__KikPo"};